<ion-content forceOverscroll="false">
    <!-- Cabecera -->
    <app-header [fixedTitle]="true">
        <app-toolbar [title]="headerTitle">
            <!-- Botón cancelar -->
            <app-toolbar-button [text]="'lbl_cancel' | translate" slot="start"
                (click)="closeModal()"></app-toolbar-button>
        </app-toolbar>
    </app-header>

    <!-- Contenido -->
    <div class="info">
        <!-- Icono -->
        <div class="icon">
            <flw-icon [name]="icon" [attr.color]="color" size="1.5x"></flw-icon>
        </div>
        <!-- Texto principal -->
        <h3>{{label}}</h3>
        <!-- Descripción -->
        <p>{{description}}</p>
    </div>

    <!-- Footer -->
    <app-footer>
        <app-button expanded (click)="closeModal()">{{btnText}}</app-button>
    </app-footer>
</ion-content>